/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Admin_No_Users_FoundInputs */

const en_mobile_admin_no_users_found = /** @type {(inputs: Mobile_Admin_No_Users_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found.`)
};

const es_mobile_admin_no_users_found = /** @type {(inputs: Mobile_Admin_No_Users_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron usuarios.`)
};

/**
* | output |
* | --- |
* | "No users found." |
*
* @param {Mobile_Admin_No_Users_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_admin_no_users_found = /** @type {((inputs?: Mobile_Admin_No_Users_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Admin_No_Users_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_admin_no_users_found(inputs)
	return en_mobile_admin_no_users_found(inputs)
});